import CityViewPageContainer from './containers/CityViewPageContainer'

export default CityViewPageContainer
